import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Star, Quote } from 'lucide-react';
import { reviews, shopInfo } from '../../mock';

export const ReviewsSection = () => {
  return (
    <section id="reviews" className="py-20 bg-stone-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-stone-100 mb-4">
            What Our Clients Say
          </h2>
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="flex items-center space-x-1">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className={`h-6 w-6 ${
                    i < Math.floor(shopInfo.rating)
                      ? 'fill-maroon-600 text-maroon-600'
                      : 'text-stone-600'
                  }`}
                />
              ))}
            </div>
            <span className="text-stone-300 text-lg font-semibold">
              {shopInfo.rating} out of 5
            </span>
          </div>
          <p className="text-lg text-stone-400">
            Based on {shopInfo.totalReviews} reviews
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reviews.map((review) => (
            <Card
              key={review.id}
              className="bg-stone-600/50 border-stone-500 backdrop-blur-sm hover:bg-stone-600 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
            >
              <CardContent className="p-6 space-y-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className={`h-4 w-4 ${
                          i < review.rating
                            ? 'fill-maroon-600 text-maroon-600'
                            : 'text-stone-600'
                        }`}
                      />
                    ))}
                  </div>
                  <Quote className="h-8 w-8 text-maroon-800/30" />
                </div>

                <p className="text-stone-300 text-sm leading-relaxed">
                  {review.text}
                </p>

                <div className="pt-4 border-t border-stone-500">
                  <p className="text-stone-100 font-semibold">{review.author}</p>
                  <p className="text-stone-500 text-xs">{review.date}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
